import { SFQ_ACCESS } from "../utils/permissions";

export const allMenuItems = [
  { id: "9",  name: "menu_organization",     path: "/Org" },
  { id: "3",  name: "menu_sop",              path: "/SOPViewer" },
  { id: "2",  name: "menu_training",         path: "/LrnMgmt" },
  { id: "1",  name: "menu_workRecord",       path: "/WorkR" },
  { id: "10", name: "menu_mthlyReport",      path: "/MthlyReport" },
  { id: "4",  name: "menu_ctInfoIndication", path: "/Indication" },
  { id: "5",  name: "menu_ctInfo",           path: "/MdcinClincTestInfoService01" },
  { id: "6",  name: "menu_ct_status",        path: "/ClinicTestOprtnInsttInfoService01" },
  // {
  //   id: "14",
  //   name: "menu_medicalDeviceInfo",
  //   path: "/MedicalDeviceClinicalTrials",
  //   cardTitle: "의료기기\n임상시험정보",
  //   cardSubtitle: "MEDICAL DEVICE",
  // },
  // {
  //   id: "15",
  //   name: "menu_medicalDeviceInstitution",
  //   path: "/MedicalDeviceInstitutions",
  //   cardTitle: "의료기기\n실시기관정보",
  //   cardSubtitle: "CLINICAL INSTITUTION",
  // },
  { id: "8",  name: "menu_pjSetup",          path: "/PrjSu" },
  { id: "7",  name: "menu_equipment",        path: "/EqptMgmt",                         divOnly: "SRD" },
  { id: "12", name: "menu_audit",            path: "/Adt",                              reviewerOnly: true },
  { id: "13", name: "menu_feasibility",      path: "/Feasibility",                      permAny: SFQ_ACCESS },
];

export const menu = [
  {
    id: "9",
    name: "menu_organization",
    path: "/Org",
  },
  {
    id: "3",
    name: "menu_sop",
    path: "/SOPViewer",
  },
  {
    id: "2",
    name: "menu_training",
    path: "/LrnMgmt",
  },
  // { id: "8", name: "menu_pjSetup", path: "/PrjSu" },
  {
    id: "1",
    name: "menu_workRecord",
    path: "/WorkR",
  },
  {
    id: "10",
    name: "menu_mthlyReport",
    path: "/MthlyReport",
  },
  {
    id: "4",
    name: "menu_ctInfoIndication",
    path: "/Indication",
  },
  {
    id: "5",
    name: "menu_ctInfo",
    path: "/MdcinClincTestInfoService01",
  },
  {
    id: "6",
    name: "menu_ct_status",
    path: "/ClinicTestOprtnInsttInfoService01",
  },
  // { id: "7", name: "menu_equipment", path: "/EqptMgmt" },
  { id: "8", name: "menu_pjSetup", path: "/PrjSu" },
  // { id: "11", name: "menu_sm", path: "/SalesMgmt" },
];

// TODO
export const menuSRD = [
  {
    id: "9",
    name: "menu_organization",
    path: "/Org",
  },
  {
    id: "3",
    name: "menu_sop",
    path: "/SOPViewer",
  },
  {
    id: "2",
    name: "menu_training",
    path: "/LrnMgmt",
  },
  // { id: "8", name: "menu_pjSetup", path: "/PrjSu" },
  {
    id: "1",
    name: "menu_workRecord",
    path: "/WorkR",
  },
  {
    id: "10",
    name: "menu_mthlyReport",
    path: "/MthlyReport",
  },
  {
    id: "4",
    name: "menu_ctInfoIndication",
    path: "/Indication",
  },
  {
    id: "5",
    name: "menu_ctInfo",
    path: "/MdcinClincTestInfoService01",
  },
  {
    id: "6",
    name: "menu_ct_status",
    path: "/ClinicTestOprtnInsttInfoService01",
  },
  { id: "7", name: "menu_equipment", path: "/EqptMgmt" },
  { id: "8", name: "menu_pjSetup", path: "/PrjSu" },
  // { id: "11", name: "menu_sm", path: "/SalesMgmt" },
];

export const menuReviewer = [
  // {
  //   id: "9",
  //   name: "menu_organization",
  //   path: "/Org",
  // },
  // {
  //   id: "2",
  //   name: "menu_training",
  //   path: "/LrnMgmt",
  // },
  // {
  //   id: "3",
  //   name: "menu_sop",
  //   path: "/SOPViewer",
  // },
  {
    id: "10",
    name: "menu_audit",
    path: "/Adt",
  },
];
